import * as moment from 'moment';
import { useState } from 'react';
import { Button, ControlLabel, Form, FormGroup, Modal } from 'react-bootstrap';
import { useAppHookContext } from '@nkr/utils/rest-api';
import { EntityType } from './place-order';

type TProps = {
    loading: boolean,
    entityType: EntityType,
    id: number,
    entityName: string,
    count: number,
    createdDate: Date,
    error: string,
    onUpdate: (id: number, count: number) => void
}

const EditPhysicalInventory = ({ loading, entityType, id, entityName, count, createdDate, error, onUpdate }: TProps) => {
    const { app: { user } } = useAppHookContext();
    const [show, setShow] = useState<boolean>(false);
    const [quantity, setQuantity] = useState<string>(count.toString());

    const dateTxt = moment(createdDate).format('MM/DD/YYYY');

    const handleQtyChange = (event) => {
        const input = event.target.value;

        if (input === '') {
            setQuantity('');
            return;
        }

        if (input === '0' || /^[1-9][0-9]*$/.test(input)) {
            setQuantity(input);
        }
    };

    const cancel = () => {
        setQuantity(count.toString());
        setShow(false);
    }

    const save = () => {
        onUpdate(id, parseInt(quantity));
        setShow(false);
    }

    return (
        <>
            <Button bsSize='xs' bsStyle='primary' block onClick={() => setShow(true)}>Edit</Button>
            <Modal bsSize='small' backdrop='static' show={show} onHide={cancel}>
                <Modal.Header closeButton>
                    <Modal.Title>Update Physical Inventory</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <FormGroup>
                            <ControlLabel>{entityType == EntityType.Center ? 'Center' : 'OPO'}</ControlLabel>{' '}
                            <label className='form-control disabled' aria-readonly>{entityName}</label>
                        </FormGroup>
                        <FormGroup>
                            <ControlLabel>Physical Inventory Date</ControlLabel>{' '}
                            <label className='form-control disabled'>{dateTxt}</label>
                        </FormGroup>
                        <FormGroup>
                            <ControlLabel>Physical Count</ControlLabel>{' '}
                            <input className='form-control' type='number' min='0' step='1' onChange={handleQtyChange} value={quantity} />
                        </FormGroup>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle='primary' onClick={save} disabled={loading || !quantity}>Update</Button>
                    <Button onClick={cancel}>Cancel</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default EditPhysicalInventory;
